// src/components/auth/AuthContext.jsx
/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from 'react';

// Crear el contexto de autenticación
const AuthContext = createContext(null);

// Hook personalizado para usar el contexto
export const useAuth = () => useContext(AuthContext);

// Exportar el contexto para el proveedor
export default AuthContext;